import React from "react";
const Frame = React.lazy(() => import('./frame'));

export const framePagesConfg = [
    {
        path: '/app/:appid',
        element:<Frame/>
    }
];